<template lang="html">
  <div
    class="brackets-grid"
    :class="[
      'brackets-grid_' + type,
      { 'brackets-grid_grand-final': grandFinal }
    ]"
  >
    <div v-if="isSingle">
      <div class="brackets-grid__container">
        <div class="brackets-grid__round" v-for="round of rounds" :key="round">
          <div
            class="brackets-grid__match"
            v-for="(pair, index) of pairs(round)"
            :key="index"
          >
            <bracket-card
              :team1="pair[0].team1"
              :team2="pair[0].team2"
              :match="pair[0].match"
            />
            <bracket-card
              :team1="pair[1].team1"
              :team2="pair[1].team2"
              :match="pair[1].match"
              v-if="round !== 0"
            />
          </div>
        </div>
        <div class="brackets-grid__round" v-if="grandFinal">
          <div class="brackets-grid__match">
            <bracket-card
              :team1="grandFinal.team1"
              :team2="grandFinal.team2"
              :match="grandFinal.match"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="brackets-grid__container" v-else>
      <template v-for="round of roundsDouble">
        <div class="brackets-grid__round" :key="'left' + round">
          <div
            v-for="(pair, index) of pairsDoubleLeft(round)"
            :key="index"
            class="brackets-grid__match"
            :data-atr="'left-' + round + '-' + index"
          >
            <bracket-card
              :team1="pair[0].team1"
              :team2="pair[0].team2"
              :match="pair[0].match"
            />
            <bracket-card
              :team1="pair[1].team1"
              :team2="pair[1].team2"
              :match="pair[1].match"
              v-if="round > 1"
            />
          </div>
        </div>
        <div class="brackets-grid__round" :key="'right' + round">
          <div
            v-for="(pair, index) of pairsDoubleRight(round)"
            :key="index"
            class="brackets-grid__match"
            :data-atr="'right-' + round + '-' + index"
          >
            <bracket-card
              :team1="pair[0].team1"
              :team2="pair[0].team2"
              :match="pair[0].match"
            />
            <bracket-card
              :team1="pair[1].team1"
              :team2="pair[1].team2"
              :match="pair[1].match"
              v-if="round > 1"
            />
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import BracketCard from "./BracketCard";

export default {
  components: {
    BracketCard
  },
  props: {
    type: { type: String, default: "single" },
    gridData: { required: true },
    rounds: { type: Array, required: true },
    grandFinal: { required: false }
  },

  data() {
    return {
      pairsDoubleRight: this.pairsDouble.bind(this, 1),
      pairsDoubleLeft: this.pairsDouble.bind(this, 2)
    };
  },

  computed: {
    roundsDouble() {
      const newArr = Array.from(this.rounds);
      newArr.pop();
      return newArr;
    },
    isSingle() {
      return this.type === "single";
    }
  },

  methods: {
    pairs(round) {
      const key = Math.pow(2, round);
      const matches = this.gridData[key] || [];
      const pairs = [];
      for (let i = 0; i < matches.length; i += 2) {
        pairs.push([matches[i], matches[i + 1]]);
      }
      return pairs;
    },

    pairsDouble(grid_type, round) {
      const matches = this.gridData.filter(
        match =>
          match.grid_type === grid_type && match.stage === Math.pow(2, round)
      );
      const pairs = [];
      for (let i = 0; i < matches.length; i += 2) {
        pairs.push([matches[i], matches[i + 1]]);
      }

      return pairs;
    }
  }
};
</script>

<style lang="scss">
.brackets-grid {
  &__container {
    display: inline-flex;
    align-items: stretch;
  }

  &__round {
    position: relative;
    width: 200px;
    display: flex;
    flex-direction: column;
    z-index: 1;

    &:not(:first-of-type) {
      width: 200px;
    }

    &:last-child {
      border-bottom-right-radius: 6px;
      overflow: hidden;
    }

    &:first-of-type {
      .bracket-card {
        // margin-left: 0;
        &__line-before {
          display: none;
        }
      }
    }

    &:last-of-type {
      .bracket-card__line-after {
        display: none;
      }
      .bracket-card__participant::after {
        display: none;
      }
    }

    &:before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      background-size: 100% 100vh;
    }

    &:nth-child(odd):before {
      background: linear-gradient(
        180deg,
        #7cd7ff 0%,
        rgba(124, 215, 255, 0.5) 100%
      );
      opacity: 0.07;
    }

    &:nth-child(even):before {
      background: linear-gradient(
        180deg,
        #7cd7ff 0%,
        rgba(124, 215, 255, 0.5) 100%
      );
      opacity: 0.1;
    }
  }

  &_single {
    .bracket-card__participant::after {
      visibility: visible;
    }
  }

  &_grand-final & {
    &__round:nth-last-child(2) {
      .bracket-card__participant::after {
        visibility: hidden;
      }
    }
  }

  &_double & {
    &__round:nth-child(even) {
      .bracket-card__participant::after {
        visibility: visible;
      }
    }
  }

  &__match {
    position: relative;
    display: flex;
    flex-direction: column;
    flex: 1 0;
    align-items: center;
    min-height: 180px;

    .bracket-card {
      margin: auto;
    }
  }
}
</style>
